// extracted by mini-css-extract-plugin
export default {"outerDiv":"ViewGalleryImgCard_outerDiv__2rFgv","innerDiv":"ViewGalleryImgCard_innerDiv__cEUdg","img":"ViewGalleryImgCard_img__kvoY0","txt":"ViewGalleryImgCard_txt__Dc9DE"};